/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Association Icon component.
 */
export const SystemAssociationIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.95222 13.6685H3.5C3.22386 13.6685 3 13.4447 3 13.1685V5.5C3 5.22386 3.22386 5 3.5 5H14.5911C14.8672 5 15.0911 5.22386 15.0911 5.5V13.1685C15.0911 13.4447 14.8672 13.6685 14.5911 13.6685H10.2575' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M17.2405 9.3418H19.7C19.9761 9.3418 20.2 9.56565 20.2 9.8418V17.5103C20.2 17.7865 19.9761 18.0103 19.7 18.0103H8.60889C8.33274 18.0103 8.10889 17.7865 8.10889 17.5103V9.8418C8.10889 9.56566 8.33274 9.3418 8.60889 9.3418H12.9569' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      //detach
      <path d='M5.95222 13.6685H3.5C3.22386 13.6685 3 13.4447 3 13.1685V5.5C3 5.22386 3.22386 5 3.5 5H14.5911C14.8672 5 15.0911 5.22386 15.0911 5.5V13.1685C15.0911 13.4447 14.8672 13.6685 14.5911 13.6685H10.2575' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M16.2405 9.3418H19.7C19.9761 9.3418 20.2 9.56565 20.2 9.8418V17.5103C20.2 17.7865 19.9761 18.0103 19.7 18.0103H8.60889C8.33274 18.0103 8.10889 17.7865 8.10889 17.5103V9.8418C8.10889 9.56566 8.33274 9.3418 8.60889 9.3418H10.9569' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M19.0002 5.49976L3.26424 17.9695' stroke={dlsColor('grey3')} strokeWidth='1.5'/>
      <path d='M20.0002 6.49951L3.947 18.9996' stroke={dlsColor('grey1')} strokeWidth='1.5'/>
    </svg>
  );
};

export default SystemAssociationIcon;
